import { EllipsisIcon, IconButton, Tooltip } from '@buffer-mono/popcorn'

import styles from './MentionsContextSection.module.css'

import type { JSX } from 'react'

type LoadMoreContextButtonProps = {
  remainingCount: number
  increment: number
  onClick: () => void
}

export const LoadMoreContextButton = ({
  remainingCount,
  increment,
  onClick,
}: LoadMoreContextButtonProps): JSX.Element => {
  const countToShow = Math.min(increment, remainingCount)

  return (
    <aside className={styles.moreRepliesIcon}>
      <Tooltip content={`Show ${countToShow} more`}>
        <IconButton
          data-testid="show-more-context-button"
          variant="tertiary"
          onClick={onClick}
          label={`Show ${countToShow} more context mentions`}
        >
          <EllipsisIcon color="subtle" />
        </IconButton>
      </Tooltip>
    </aside>
  )
}
